import Model from './Model'

export default class Account extends Model {
  resource() {
    return 'accounts'
  }
}
